const updateSelectedVariant = ({ variant, variantInventory = [], elements = {}, strings = {} }) => {
  const { atcButtonMsgShort, atcButtonMsgFull, optionValueElement } = elements;

  const current = variantInventory.find(v => v.id === variant.id);
  const isPreOrder = current && !current.available && current.inventory_policy === 'continue';
  const isSoldOut = !variant.available && !isPreOrder;

  const getAtcBtnText = () => {
    if (isSoldOut) return strings.soldOut;
    if (isPreOrder) return strings.preOrder;
    return strings.addToCart;
  };

  const label = getAtcBtnText();
  const shortLabel =
    isSoldOut || isPreOrder ? label : strings.addToCartShort || label;

  if (atcButtonMsgShort) {
    atcButtonMsgShort.textContent = shortLabel;
  }
  if (atcButtonMsgFull) {
    atcButtonMsgFull.textContent = label;
  }

  if (optionValueElement) {
    optionValueElement.textContent = variant.title;
  }
};

export default updateSelectedVariant;
